const shipmentResponseToShipmentObject = (response) => {
    return {
        id: response.id,
        // batch: Not found in ShipmentDto
        createdAt: response.shipment_date, // Using shipment_date as the closest match
        // purchased: Not found in ShipmentDto
        // manifested: Not found in ShipmentDto
        // deliveryTime: Not found in ShipmentDto
        serviceName: response.record_service,
        // serviceDisplayName: Not found in ShipmentDto
        baseCharge: response.record_base_charge_amount,
        totalCharge: response.record_total_charge_amount,
        zone: response.record_zone,
        orderDate: response.order_date,
        // sourceType: Not found in ShipmentDto
        // sourceId: Not found in ShipmentDto
        // sourceName: Not found in ShipmentDto
        trackingNumber: response.tracking_number,
        // base64Labels: Not found in ShipmentDto
        fromAddress: {
            companyName: response.from_address_company_name,
            firstName: response.from_address_first_name,
            middleName: response.from_address_middle_name,
            lastName: response.from_address_last_name,
            email: response.from_address_email,
            phone: response.from_address_phone,
            street1: response.from_address_street1,
            street2: response.from_address_street2,
            street3: response.from_address_street3,
            cityLocality: response.from_address_city_locality,
            stateProvince: response.from_address_state_province,
            postalCode: response.from_address_postal_code,
            countryCode: response.from_address_country_code,
            residentialIndicator: response.from_address_residential_indicator,
        },
        toAddress: {
            companyName: response.to_address_company_name,
            firstName: response.to_address_first_name,
            middleName: response.to_address_middle_name,
            lastName: response.to_address_last_name,
            email: response.to_address_email,
            phone: response.to_address_phone,
            street1: response.to_address_street1,
            street2: response.to_address_street2,
            street3: response.to_address_street3,
            cityLocality: response.to_address_city_locality,
            stateProvince: response.to_address_state_province,
            postalCode: response.to_address_postal_code,
            countryCode: response.to_address_country_code,
            residentialIndicator: response.to_address_residential_indicator,
        },
        // returnToAddress: Not found in ShipmentDto
        externalOrderId: response.external_order_id,
        shipDate: response.shipment_date,
        warehouseId: response.warehouse_id,
        service: response.record_service,
        carrier: response.record_carrier,
        // carrierAccountId: Not found in ShipmentDto
        // orderNumber: Not found in ShipmentDto, but external_order_id might be used
        // shipmentOptions: Not found in ShipmentDto
        // nonDeliveryOption: Not found in ShipmentDto
        // returnsIndicator: Not found in ShipmentDto
        // items: Not found in ShipmentDto
        // customs: Not found in ShipmentDto
        package: {
            id: response.id, // Using the shipment id as package id
            packageType: response.package_type,
            weightValue: response.weight,
            weightUnit: response.weight_unit,
            insuredValueValue: response.insured_value,
            insuredValueUnit: response.insured_value_unit,
            dimensionsLength: response.length,
            dimensionsWidth: response.width,
            dimensionsHeight: response.height,
            dimensionsUnit: response.dimensions_unit,
            cubic: response.record_cubic,
            ratingWeightValue: response.record_rated_weight,
            ratingWeightUnit: response.record_rated_weight_unit,
            ratingDimensionsLength: response.record_rated_length,
            ratingDimensionsWidth: response.record_rated_width,
            ratingDimensionsHeight: response.record_rated_height,
        },
        // carrierManifest: Not found in ShipmentDto
    };
};

export { shipmentResponseToShipmentObject };
